import { BluetoothAdapterProvider } from '@services/bluetooth/adapter/BluetoothAdapterProvider';

const bluetoothAdapter = BluetoothAdapterProvider.get();

/**
 * Client for making cross frame calls to bluetoothSerialCommService in ATBase.
 */
export class BluetoothSerialCommService {
    // Public functions
    /**
     * sends command and receives data from the device for serial connection
     * @param config
     * @returns {*}
     */
    public static requestDataSerialComm(config) {
        return bluetoothAdapter.requestDataSerialComm(config);
    }

    /**
     * sends data to the device for serial data connection
     * @param config
     * @returns {*}
     */
    public static writeDataSerialComm(config) {
        return bluetoothAdapter.writeDataSerialComm(config);
    }

    /**
     * disconnect the serially connected device
     * @param config
     * @returns {*}
     */
    public static disconnectSerialComm(config) {
        return bluetoothAdapter.disconnectSerialComm(config);
    }

    /**
     * changes the Standard charset for serial data connection
     * @param config
     * @returns {*}
     */
    public static changeCharsetSerialComm(config) {
        return bluetoothAdapter.changeCharsetSerialComm(config);
    }
}
